import { render, staticRenderFns } from "./SegmentedSelect.vue?vue&type=template&id=2224eb16&scoped=true&"
import script from "./SegmentedSelect.vue?vue&type=script&lang=js&"
export * from "./SegmentedSelect.vue?vue&type=script&lang=js&"
import style0 from "./SegmentedSelect.vue?vue&type=style&index=0&id=2224eb16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224eb16",
  null
  
)

export default component.exports